import { PRODUCTS } from '@/utilities/constants/game';
import { Balance } from '@fanduel/cpe-um-bundle/wallet/contract';
import { useStore } from '@/store/useStore';

export type CasinoBalance = {
  playableBalance: number;
  casinoDeposits: number;
  casinoBonuses: number;
  sharedWinnings: number;
  freeBets: number;
  total?: number;
  inGamePlayableBalance?: number;
  inGameEligibleBonus?: number;
  inGameDeposits?: number;
  inGameSharedWinnings?: number;
  inGameBalanceActive?: boolean;
};

export const normalizeWalletResponse = (
  walletBalance: Set<Balance>,
): CasinoBalance => {
  const details = Array.from(walletBalance).reduce(
    (accumulator, { accountType, balance }) => {
      return { ...accumulator, [accountType]: balance };
    },
    {},
  );

  return {
    playableBalance:
      useStore.getState().runtime.product === PRODUCTS.POKER
        ? details['POKER_PLAYABLE']
        : details['CASINO_PLAYABLE'],
    casinoDeposits: details['USER_SPORTSBOOK_DEPOSIT'],
    casinoBonuses: details['USER_CASINO_BONUS'],
    freeBets: details['CASINO_FREE_BETS'],
    sharedWinnings: details['SHARED_WINNINGS'],
  };
};
